import styles from './MainContent.module.scss';
import React from 'react';
import { showcaseProducts } from '../../../homepage/ProductShowCase/constants';
import BlogProductCard from '../BlogProductCard/BlogProductCard';
import { Typography } from '@mui/material';
import Link from 'next/link';
const MainContent = ({ data, tagsList, currentPathname }) => {
  const tagsName = tagsList;
  const matchingTags = tagsName?.filter((tag) => data?.tags.includes(tag.id));
  //function to get the product based on category
  const result = showcaseProducts[data?.selected_product];
  return (
    <div className={styles.mainContentContainer}>
      <div className={styles.leftContainer}>
        <div
          className="blog-main"
          dangerouslySetInnerHTML={{
            __html: data?.content?.rendered,
          }}
        ></div>
        <div className={styles.referenceArticleWrapper}>
          {data?.product_card && JSON.parse(data?.product_card) && (
            <div className={styles.rightContainer}>
              <div className={styles.productContainer}>
                <Typography variant="h5" color="primary.main">
                  Referenced in this Article
                </Typography>
                <BlogProductCard {...result} />
              </div>
            </div>
          )}
        </div>
        {matchingTags && matchingTags.length > 0 && (
          <React.Fragment>
            <div className={styles.divider}></div>
            <div className={styles.tagsContainer}>
              <Typography
                variant="h5"
                className={styles.tagsTitle}
                color="primary.black"
              >
                Tags Used in this Article:
              </Typography>
              <Typography
                variant="p3"
                className={styles.tags}
                color="primary.main"
              >
                {matchingTags.map((tag, index) => (
                  <React.Fragment key={tag.id}>
                    <Link href={`/${currentPathname}/tag/${tag.slug}`}>
                      <a>{tag.name}</a>
                    </Link>
                    {index < matchingTags.length - 1 && ','}
                  </React.Fragment>
                ))}
              </Typography>
            </div>
          </React.Fragment>
        )}
      </div>
    </div>
  );
};

export default MainContent;
